
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/privacy-policy",
      function () {
        return require("private-next-pages/docs/privacy-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/privacy-policy"])
      });
    }
  